import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroPlantillas'
})
export class FiltroPlantillasPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
   
    //console.log(arreglo)

    if(texto ===''){
      return arreglo
    }
    if( arreglo.length === 0 ) {
      return arreglo;
    }

    texto = texto.toLocaleLowerCase()

    return arreglo.filter (item=>{

    
      return item.numero_destino.toLocaleLowerCase().includes(texto)
     
    })
   
    return arreglo;
  }

}